import { createSlice } from '@reduxjs/toolkit';

/* const initialState = {
    firstName: "sisi",
    lastName: "sisi",
    countryCode: "Afghanistan",
    mobileNum: "2222222222",
    email: "mail@grenssnitt.com"
}; 
 */
const initialState = {};

const primConSlice = createSlice({
    name: "primContract",
    initialState,
    reducers: {
        primaryContractAdded(state, action) {         
            return {
				...state,
				firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                countryCode: action.payload.countryCode,
                mobileNum: action.payload.mobileNum,
                email: action.payload.email
			};
        }
    }
});

export const primaryContractSelector = (state) => state.primContract;

export const { primaryContractAdded } = primConSlice.actions
export default primConSlice.reducer
